import { Calendar, List } from 'lucide-react';

export type ProgrammingViewMode = 'list' | 'calendar';

interface ViewToggleProps {
  viewMode: ProgrammingViewMode;
  onChange: (mode: ProgrammingViewMode) => void;
}

/**
 * Toggle between list and calendar views for programming pages.
 * Shared across all portals (agent, affiliate, member, individual, admin).
 */
export function ViewToggle({ viewMode, onChange }: ViewToggleProps) {
  return (
    <div className="flex rounded-lg border border-border overflow-hidden">
      <button
        type="button"
        onClick={() => onChange('list')}
        className={`flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium transition-colors ${
          viewMode === 'list'
            ? 'bg-primary text-primary-foreground'
            : 'bg-background text-muted-foreground hover:text-foreground'
        }`}
      >
        <List className="h-4 w-4" />
        List
      </button>
      <button
        type="button"
        onClick={() => onChange('calendar')}
        className={`flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium transition-colors ${
          viewMode === 'calendar'
            ? 'bg-primary text-primary-foreground'
            : 'bg-background text-muted-foreground hover:text-foreground'
        }`}
      >
        <Calendar className="h-4 w-4" />
        Calendar
      </button>
    </div>
  );
}
